<template>
  <div id="data-list-keyChains" class="data-list-container">
    <vs-table ref="table" responsive pagination :max-items="itemsPerPage" search :data="originList">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2">{{ minItemsPerPage }} - {{ currentItemsPerPage }} of {{ queriedItems }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 50">
                <span>50</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="description">Descripción</vs-th>
        <vs-th sort-key="fakeKey">Clave</vs-th>
        <!-- <vs-th sort-key="activity">Original</vs-th> -->
        <vs-th sort-key="status">Estado</vs-th>
        <vs-th>Acciones</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.description }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.fakeKey }}</p>
            </vs-td>
            <!-- <vs-td>
                            <p class="product-category">{{ tr.secretKey | decodeBase64 }}</p>
                        </vs-td> -->

            <vs-td>
              <vs-progress :percent="100" :color="tr.status | getPopularityColor" class="shadow-md" />
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                class="ml-2"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                @click.stop="deleteData(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import * as Keychains from "./Keychains";
import { notify } from "@/helpers/$vs.js";
// import security from '@/helpers/security';

export default {
  data() {
    return {
      listGroups: [],

      recordId: null,
      originList: [],
      itemsPerPage: 7,
      isMounted: false
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        // return this.$refs.table.currentx;
        return true;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.originList.length;
    },
    minItemsPerPage() {
      return this.currentPage * this.itemsPerPage - (this.itemsPerPage - 1);
    },
    currentItemsPerPage() {
      return this.originList.length - this.currentPage * this.itemsPerPage > 0
        ? this.currentPage * this.itemsPerPage
        : this.originList.length;
    }
  },
  filters: {
    getPopularityColor(status) {
      switch (status) {
        case "Active":
          return "primary";
          break;
        case "Inactive":
          return "warning";
          break;
        case "Blocked":
          return "danger";
          break;
        case "Banned":
          return "danger";
          break;
        case "Deleted":
          return "danger";
          break;
        default:
          return "warning";
          break;
      }
    }
  },
  methods: {
    receiveMessageToUpdate() {
      this.$root.$on("UPDATE_KEYCHAIN_LIST", args => {
        console.log("receiveMessageToUpdate fn:", args);
        this.getAllKeys();
      });
    },
    async getAllKeys() {
      this.$vs.loading({ type: "sound" });

      try {
        const result = await Keychains.getAllKeys();
        this.originList = result;
      } catch (error) {
        console.error("getAllForms Error:", error);
        const message = error.error ? error.error : `(${error.message})`;
        let text = "";
        if (message === "KeyChains are empty") text = `No hay claves map registrados.`;
        notify("Lista de Formularios", text, "warning");
      } finally {
        this.$vs.loading.close();
      }
    },

    deleteData(data) {
      this.recordId = data.key;

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Eliminar Clave: ${data.description}`,
        text: "Ésta opción no se puede deshacer, está seguro?",
        acceptText: "Aceptar",
        cancelText: "Cancelar",
        accept: this.deleteItem
      });
    },

    async deleteItem() {
      this.$vs.loading({ type: "sound" });

      try {
        await Keychains.deleteKey(this.recordId);
      } catch (error) {
        console.log("deleteItem Error:", error);

        this.$vs.notify({
          title: "Eliminar Clave",
          text: "Ocurrio un error, al eliminar la Clave",
          color: "warning",
          icon: "error",
          time: 6000
        });
      } finally {
        this.recordId = null;
        this.$vs.loading.close();
        await this.getAllKeys();
      }
    },

    infoData(data) {
      this.$vs.notify({
        title: "Gestor de Claves",
        text: "Acción no disponible de momento",
        color: "warning",
        icon: "error",
        time: 4500
      });
    }
  },
  mounted() {
    this.isMounted = true;
    this.getAllKeys();
    this.receiveMessageToUpdate();
  }
};
</script>

<style lang="scss">
#data-list-keyChains {
  @import "@/assets/css/_themeTable.scss";
}
</style>
